import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"inner-banner\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"banner-content text-center\"><h1>Casual Portal</h1><span></span></div></div></div></div></div>", 1)
const _hoisted_2 = { class: "job-listing-area pt-120 mb-120" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row g-lg-4 gy-5" }
const _hoisted_5 = { class: "col-lg-12 order-lg-2 order-1" }
const _hoisted_6 = { class: "job-listing-wrrap" }
const _hoisted_7 = {
  key: 0,
  class: "row"
}
const _hoisted_8 = {
  key: 0,
  class: "p-5"
}
const _hoisted_9 = { class: "d-flex justify-content-center py-5" }
const _hoisted_10 = { class: "job-listing-card" }
const _hoisted_11 = { class: "job-top" }
const _hoisted_12 = { class: "job-list-content" }
const _hoisted_13 = { class: "company-area" }
const _hoisted_14 = { class: "logo" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "company-details" }
const _hoisted_17 = { class: "name-location" }
const _hoisted_18 = { class: "job-discription" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Location:", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Qualification:", -1)
const _hoisted_21 = { class: "job-type-apply" }
const _hoisted_22 = { class: "job-type" }
const _hoisted_23 = { class: "light-blue" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "apply-btn" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "assets/images/icon/apply-ellipse.svg",
    alt: ""
  })
], -1)
const _hoisted_28 = { class: "col-lg-12 d-flex justify-content-center" }
const _hoisted_29 = {
  key: 1,
  class: "row"
}
const _hoisted_30 = { class: "col-12" }
const _hoisted_31 = { class: "form-wrapper" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "section-title text-center" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Message"),
  /*#__PURE__*/_createElementVNode("div", { class: "dash" })
], -1)
const _hoisted_33 = { class: "profile-form" }
const _hoisted_34 = { class: "section-title2" }
const _hoisted_35 = {
  key: 0,
  class: "row"
}
const _hoisted_36 = { class: "col-md-12" }
const _hoisted_37 = { class: "form-inner mb-25" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { for: "message" }, "Message *", -1)
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "col-md-12" }
const _hoisted_41 = { class: "form-inner" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = {
  key: 1,
  class: "primry-btn-2 lg-btn w-unset",
  type: "button"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "me-3 fs-6 text-white" }, "Processing...", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white ms-3",
  style: {"font-size":"24px"}
}, null, -1)
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = {
  key: 2,
  class: "row"
}
const _hoisted_48 = { class: "col-12" }
const _hoisted_49 = { class: "form-wrapper" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "section-title text-center" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Send Email "),
  /*#__PURE__*/_createElementVNode("div", { class: "dash" })
], -1)
const _hoisted_51 = { class: "profile-form" }
const _hoisted_52 = { class: "section-title2" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-md-12" }
const _hoisted_55 = { class: "form-inner mb-25" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { for: "subject" }, "Subject *", -1)
const _hoisted_57 = { class: "input-area" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_59 = { class: "col-md-12" }
const _hoisted_60 = { class: "form-inner mb-25" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { for: "mailBody" }, "Message Body*", -1)
const _hoisted_62 = { class: "col-md-12" }
const _hoisted_63 = { class: "form-inner" }
const _hoisted_64 = {
  key: 1,
  class: "primry-btn-2 lg-btn w-unset",
  type: "button"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "me-3 fs-6 text-white" }, "Processing...", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white ms-3",
  style: {"font-size":"24px"}
}, null, -1)
const _hoisted_67 = [
  _hoisted_65,
  _hoisted_66
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (!_ctx.showForm && !_ctx.mailFormShow)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_ctx.pageLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_ProgressSpinner)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobSeekers, (seeker) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: seeker.id,
                        class: "col-lg-12 mb-30"
                      }, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("img", {
                                    src: (seeker.photo) ? seeker.photo : 'https://loremflickr.com/52/52/logo,organisation/all',
                                    alt: ""
                                  }, null, 8, _hoisted_15)
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("div", _hoisted_17, [
                                    _createVNode(_component_router_link, {
                                      to: 'job-seeker/' + seeker.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("h5", null, _toDisplayString(seeker.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]),
                                    _createElementVNode("p", null, _toDisplayString(seeker.description), 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("ul", null, [
                                  _createElementVNode("li", null, [
                                    _createElementVNode("p", null, [
                                      _hoisted_19,
                                      _createTextVNode(" " + _toDisplayString(seeker.job_location?.name ?? 'No Location'), 1)
                                    ])
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("p", null, [
                                      _hoisted_20,
                                      _createTextVNode(_toDisplayString(seeker.qualification?.name ?? 'No Qualification'), 1)
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("span", null, "Total reviews: (" + _toDisplayString(seeker.reviews?.length ?? 0) + ")", 1)
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("span", _hoisted_23, _toDisplayString(seeker.designation ?? "No Designation"), 1),
                              _createElementVNode("button", {
                                class: "primry-btn-2 p-1 px-3",
                                onClick: ($event: any) => (_ctx.openForm(seeker))
                              }, "Send Sms", 8, _hoisted_24),
                              _createElementVNode("button", {
                                class: "primry-btn-2 p-1 px-3",
                                onClick: ($event: any) => (_ctx.openMailForm(seeker))
                              }, "Send Email", 8, _hoisted_25)
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_router_link, {
                                to: 'job-seeker/' + seeker.id
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_27,
                                  _createTextVNode(" Detail Job Seeker ")
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ])
                          ])
                        ])
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_Paginator, {
                        first: _ctx.currentPage,
                        "onUpdate:first": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
                        rows: _ctx.rowsPerPage,
                        totalRecords: _ctx.totalPages,
                        onPage: _ctx.handlePageChange
                      }, null, 8, ["first", "rows", "totalRecords", "onPage"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showForm)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _createElementVNode("form", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("h5", null, "To: " + _toDisplayString(_ctx.smsForm.full_name) + " Phone: " + _toDisplayString(_ctx.smsForm.last_four ?? "Not exists"), 1)
                          ]),
                          (_ctx.smsForm.receiver_number != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _createElementVNode("div", _hoisted_36, [
                                  _createElementVNode("div", _hoisted_37, [
                                    _hoisted_38,
                                    _withDirectives(_createElementVNode("textarea", {
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.smsForm.message) = $event)),
                                      id: "message",
                                      placeholder: "Message",
                                      disabled: _ctx.smsForm.last_four == null
                                    }, null, 8, _hoisted_39), [
                                      [_vModelText, _ctx.smsForm.message]
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("div", _hoisted_41, [
                                    (!_ctx.isLoading)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: "primry-btn-2 lg-btn w-unset",
                                          type: "button",
                                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args))),
                                          disabled: _ctx.smsForm.last_four == null
                                        }, "Send SMS", 8, _hoisted_42))
                                      : (_openBlock(), _createElementBlock("button", _hoisted_43, _hoisted_46)),
                                    (!_ctx.isLoading)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 2,
                                          class: "primry-btn-2 lg-btn w-unset float-end",
                                          type: "button",
                                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
                                        }, "Cancel"))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.mailFormShow)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _createElementVNode("form", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("h5", null, "To: " + _toDisplayString(_ctx.mailForm.full_name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("div", _hoisted_55, [
                                _hoisted_56,
                                _createElementVNode("div", _hoisted_57, [
                                  _hoisted_58,
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.mailForm.subject) = $event)),
                                    type: "text",
                                    id: "subject",
                                    name: "subject"
                                  }, null, 512), [
                                    [_vModelText, _ctx.mailForm.subject]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("div", _hoisted_60, [
                                _hoisted_61,
                                _withDirectives(_createElementVNode("textarea", {
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.mailForm.body) = $event)),
                                  id: "mailBody",
                                  placeholder: "Write here..."
                                }, null, 512), [
                                  [_vModelText, _ctx.mailForm.body]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_62, [
                              _createElementVNode("div", _hoisted_63, [
                                (!_ctx.isLoading)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "primry-btn-2 lg-btn w-unset",
                                      type: "button",
                                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.sendEmail && _ctx.sendEmail(...args)))
                                    }, "Send Mail"))
                                  : (_openBlock(), _createElementBlock("button", _hoisted_64, _hoisted_67)),
                                (!_ctx.isLoading)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      class: "primry-btn-2 lg-btn w-unset float-end",
                                      type: "button",
                                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeMailForm && _ctx.closeMailForm(...args)))
                                    }, "Cancel"))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}